"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_select_1 = __importDefault(require("vue-select"));
exports.default = vue_1.default.extend({
    components: { vSelect: vue_select_1.default },
    props: ['name', 'label', 'type', 'noValueLabel', 'multiple', 'required', 'role'],
    data: function () {
        var model = this.$root.$data;
        var value = model.data != null ? (model.data[this.name] || []) : [];
        var data = {
            options: [],
            selectedRole: this.role || '',
            availableRoles: null,
            serializedValue: JSON.stringify(value),
            other: false,
            selected: value,
            otherIntervenant: {
                firstName: '',
                lastName: '',
                email: '',
            },
            readonly: model.readOnly,
            candelete: model.canDelete
        };
        return data;
    },
    mounted: function () {
        this.loadAvailableRoles();
    },
    methods: {
        isLabelVisible: function () {
            return this.label !== null && this.label !== '';
        },
        getCssForDiv: function () {
            //if (this.isLabelVisible()) {
            //    return 'col-9';
            //}
            return 'col-12';
        },
        isEmail: function (email) {
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
        },
        setSelected: function (selected) {
            this.selected = selected;
            this.serializedValue = JSON.stringify(selected);
        },
        addOther: function () {
            var intervenant = this.otherIntervenant;
            if (!intervenant.firstName || !intervenant.lastName || !intervenant.email || !this.isEmail(intervenant.email)) {
                return false;
            }
            this.onChange(intervenant);
            intervenant.firstName = "";
            intervenant.lastName = "";
            intervenant.email = "";
            return false;
        },
        toggleOther: function () {
            this.other = !this.other;
        },
        getOptions: function (search, loading) {
            var model = this.$root.$data;
            var self = this;
            loading(true);
            $.ajax({
                url: '/Affaires/GetIntervenants',
                type: 'get',
                data: {
                    search: search,
                    roles: model.roles,
                    id: model.affaireId,
                    entrepriseid: model.entrepriseId
                }
            }).done(function (data) {
                self.options = data.items;
                loading(false);
            });
        },
        loadAvailableRoles: function () {
            if (this.availableRoles !== null) {
                return;
            }
            var model = this.$root.$data;
            var self = this;
            $.ajax({
                url: '/Affaires/GetAvailableRoles',
                type: 'get',
                data: {
                    id: model.affaireId
                }
            }).done(function (data) {
                self.availableRoles = data.items;
            });
        },
        updateData: function () {
            this.setSelected(this.selected);
        },
        onChange: function (item) {
            if (item == null) {
                return;
            }
            var selected = this.selected;
            var newItem = $.extend({}, item);
            newItem.role = this.selectedRole;
            if (this.multiple !== undefined || selected.length == 0) {
                selected.push(newItem);
            }
            else {
                selected = [newItem];
            }
            this.setSelected(selected);
            // Vide la sélection
            this.$refs.select.mutableValue = null;
        },
        getLabel: function (option) {
            return (option.id ? '' : '🗋 ') + (option.firstName + " " + option.lastName + " <" + option.email + ">");
        },
        deleteIntervenant: function (item) {
            this.setSelected(this.selected.filter(function (i) { return !(i.email == item.email && i.role == item.role); }));
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/SelectIntervenant.vue
// module id = 190
// module chunks = 0